import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { SITE, avisoNoOficial } from "@/config/site";

const linkCls = "underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#5FD3C6]";

export const Footer = () => (
  <footer className="bg-[#072A42] pb-28 pt-12 text-[#D5E2EA] sm:pb-14" data-testid="site-footer">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <div className="grid gap-8 md:grid-cols-3">
        <div>
          <Logo light />
          <p className="mt-4 text-[16px] leading-relaxed">Te orientamos sobre planes de salud según tu caso. La información es referencial y las condiciones finales las define cada Isapre.</p>
        </div>
        <div className="space-y-2 text-[16px]">
          <p className="font-bold text-white">Contacto</p>
          <p><a href={`tel:+${SITE.telefono}`} className={linkCls} data-testid="footer-phone">{SITE.telefonoDisplay}</a></p>
        </div>
        <div className="space-y-2 text-[16px]">
          <p className="font-bold text-white">Legal</p>
          <p><Link to="/privacidad" className={linkCls} data-testid="footer-privacy">Política de privacidad</Link></p>
          <p><Link to="/terminos" className={linkCls} data-testid="footer-terms">Términos y condiciones</Link></p>
        </div>
      </div>
      <div className="mt-10 space-y-2 border-t border-white/15 pt-6 text-[14px] leading-relaxed">
        <p>La información es referencial. Las condiciones, coberturas y precios dependen de cada plan y de tu situación particular.</p>
        <p>{avisoNoOficial}</p>
        <p>© {new Date().getFullYear()} {SITE.brand}</p>
      </div>
    </div>
  </footer>
);
